import React, { useEffect, useState } from "react";
import arrowLeft from "../assets/images/navbar/arrow-left.png";
import cancel from "../assets/images/navbar/cancel.png";
import { staticContentService } from "../services";
import { StaticPageSlug } from "../utils/types";

type StaticContentPageProps = {
  slug: StaticPageSlug;
  title: string;
  onClose: () => void;
};

const StaticContentPage = ({ slug, title, onClose }: StaticContentPageProps) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const response: any = await staticContentService.getPage(slug);
        if (response.status && response.data?.content) {
          setContent(response.data.content);
        } else {
          setError(response.message || `Unable to load ${title.toLowerCase()}`);
        }
      } catch (err: any) {
        setError(err?.message || `Unable to load ${title.toLowerCase()}`);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug, title]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[70]" onClick={onClose}>
      <div
        className="fixed right-0 top-0 h-full w-full max-w-[450px] bg-white dark:bg-gray-900 rounded-l-[20px] overflow-y-auto flex flex-col"
        style={{ animation: "slideInRight 0.3s ease-out" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white dark:bg-gray-900 z-10 px-6 py-4 border-b dark:border-gray-700">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img src={arrowLeft} alt="back" className="w-[36px] h-[36px] rounded-full border cursor-pointer p-2" onClick={onClose} />
              <h2 className="text-[#040404] dark:text-gray-200 font-Urbanist text-[20px] font-semibold">{title}</h2>
            </div>
            <img src={cancel} alt="close" className="w-[36px] h-[36px] p-2 rounded-full border cursor-pointer" onClick={onClose} />
          </div>
        </div>
        <div className="flex-1 px-6 py-4">
          {loading ? (
            <div className="flex justify-center py-16">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FF8A00]"></div>
            </div>
          ) : error ? (
            <p className="text-gray-500">{error}</p>
          ) : (
            <div
              className="prose dark:prose-invert max-w-none text-[#050505] dark:text-gray-200 font-Urbanist"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StaticContentPage;
